import { render, staticRenderFns } from "./SupportStatistic.vue?vue&type=template&id=523a730a&scoped=true&"
import script from "./SupportStatistic.vue?vue&type=script&lang=js&"
export * from "./SupportStatistic.vue?vue&type=script&lang=js&"
import style0 from "./SupportStatistic.vue?vue&type=style&index=0&id=523a730a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a730a",
  null
  
)

export default component.exports